











































import { Component, Vue } from "vue-property-decorator"

@Component({})
export default class WpFooter extends Vue {
  menu = [
    {
      text: "Use Cases",
      href: "",
    },
    {
      text: "Industry",
      href: "",
    },
    {
      text: "Human Resources",
      href: "",
    },
    {
      text: "About Quescreen",
      href: "",
    },
    {
      text: "Additional Services",
      href: "",
    },
    {
      text: "Frequently Asked Questions",
      href: "",
    },
  ]

  usingQuescreen = [
    {
      text: "Login",
      href: ""
    },
    {
      text: "Contact Us",
      href: ""
    },
    {
      text: "Get Started",
      href: ""
    }
  ]
}
